import React from 'react'
import PatientSearchCard from './PatientSearchCard'
import TopSearchSpecialties from './TopSearchSpecialties'
import NearbyHospitals from './NearbyHospitals'
import PeopleKnowWidget from 'common/PeopleKnowWidget'

export default function PatientHome() {
  return (
    <div>
        {/** Patient Search Card */}
        <PatientSearchCard />
        <div className='nex-flex nex-main-area-wrap align-items-start'>
          <div className="left-content">
            <TopSearchSpecialties />
            <NearbyHospitals />
          </div>
          <div className="nex-sidebar v2 col">
            <PeopleKnowWidget speciality={"Acupuncturist"} />
          </div>
        </div>
        
        </div>
  )
}
